import React from 'react'

export default function SymbolInfo() {
  return (
    <div>SymbolInfo</div>
  )
}
